import React from "react";
import "./css/style.css";
import { Home } from "components/Home";

export const App = () => {
  return (
    <div>
      <Home />
    </div>
  );
};
